import { Component, OnInit } from "@angular/core";
import {
    NURSERIES_SPHERE_SELECTOR
} from "../../../crossconcern/utilities/properties/selector.property";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";

@Component({
    selector: NURSERIES_SPHERE_SELECTOR,
    styles: [],
    templateUrl: "spheres.component.html"
})
export class NurseriesSphereComponent extends BaseComponent implements OnInit {

    public nurseryUUID: string;
    public startUUID: string;

    constructor(
        protected appComponent: AppComponent,
        protected router: Router,
        protected location: Location,
        private activeRoute: ActivatedRoute,
        protected alertUtils: AlertUtils) {
        super(appComponent, router, alertUtils, location);
    }

    public ngOnInit(): void {
        this.activeRoute.params.subscribe(
            (params) => {
                this.nurseryUUID = params.id;
            }
        );
        this.activeRoute.queryParams.subscribe(
            (params) => {
                this.startUUID = params.start;
            }
        );
    }
}